import { computed, ref } from "vue";
import { defineStore } from "pinia";

export const useBootstrapStore = defineStore("bootstrap", () => {
  // State
  const _initialDataLoaded = ref<boolean>(false);

  // Getters
  const initialDataLoaded = computed(() => _initialDataLoaded.value);

  // Actions
  const setInitialDataLoaded = (loaded: boolean) => {
    _initialDataLoaded.value = loaded;
  };

  return {
    initialDataLoaded,
    setInitialDataLoaded,
  };
});
